var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipsisV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.25C1.29688 5.25 0.75 5.83594 0.75 6.5C0.75 7.20312 1.29688 7.75 2 7.75C2.66406 7.75 3.25 7.20312 3.25 6.5C3.25 5.83594 2.66406 5.25 2 5.25ZM0.75 1.8125C0.75 2.51562 1.29688 3.0625 2 3.0625C2.66406 3.0625 3.25 2.51562 3.25 1.8125C3.25 1.14844 2.66406 0.5625 2 0.5625C1.29688 0.5625 0.75 1.14844 0.75 1.8125ZM0.75 11.1875C0.75 11.8906 1.29688 12.4375 2 12.4375C2.66406 12.4375 3.25 11.8906 3.25 11.1875C3.25 10.5234 2.66406 9.9375 2 9.9375C1.29688 9.9375 0.75 10.5234 0.75 11.1875Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisV);
export default __webpack_public_path__ + "static/media/ellipsis-v.723d5bb3.svg";
export { ForwardRef as ReactComponent };